/**
 * @file Helper class for dynamically inject columns in a list.
 * @author Tom Verschoore de la Houssaije
 */
/**
 * Helper class for dynamically inject columns in a list.
 */
var ColumnProvider = /** @class */ (function () {
    /**
     * Constructs a ColumnProvider
     */
    function ColumnProvider(container) {
        this.container = container;
        /** The column field configuration. */
        this.field = undefined;
        /** The block/module name. */
        this.block = undefined;
        /** Path to the value property, thus excluding the value property  */
        this.path = [];
        /** The name of the value property. The value property was the last item in the path. */
        this.valueProperty = '';
        this.field = this.container.field;
        this.path = this.field.name.split('.');
        this.valueProperty = this.path.pop();
    }
    Object.defineProperty(ColumnProvider.prototype, "entity", {
        /** Gets the entity of the displayed value. */
        get: function () {
            if (this.container === undefined) {
                return null;
            }
            // The entity in the path that holds the value property.
            var valueEntity = this.container.entity;
            if (this.path.length === 0 || !valueEntity) {
                return valueEntity;
            }
            this.path.find(function (segment) {
                valueEntity = valueEntity[segment];
                return !valueEntity;
            });
            return valueEntity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnProvider.prototype, "root", {
        /**
         * Gets the root entity of the binding path
         * @readonly
         * @type {*}
         */
        get: function () {
            if (this.container === undefined) {
                return null;
            }
            // The root entity of the binding path
            return this.container.entity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnProvider.prototype, "value", {
        /** Gets the displayed value of the column */
        get: function () {
            // The entity in the path that holds the value property.
            var valueEntity = this.entity;
            if (valueEntity == null) {
                return null;
            }
            return valueEntity[this.valueProperty];
        },
        /** Sets the displayed value of the column */
        set: function (val) {
            // The entity in the path that holds the value property.
            var valueEntity = this.entity;
            if (valueEntity === null) {
                return;
            }
            valueEntity[this.valueProperty] = val;
        },
        enumerable: true,
        configurable: true
    });
    return ColumnProvider;
}());
export { ColumnProvider };
